import { ReactNode } from 'react';
import { useLingui } from '@lingui/react/macro';
import { useQueryClient } from '@tanstack/react-query';

import FileUpload from '@/components/FileUpload';
import { TEMPORARY_ID_PREFIX } from '@/models/article';
import { Medium } from '@/models/medium';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const DefectPhotos = ({
  action,
  defect,
  size = 'medium',
  isDisabled,
  isInvalid,
  label,
  secondaryActionIconOnly,
}: {
  action?: { id: string; media: Medium[] };
  defect?: { id: string; media: Medium[] };
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
  isDisabled?: boolean;
  isInvalid?: boolean;
  label?: ReactNode;
  secondaryActionIconOnly?: boolean;
}) => {
  const { t } = useLingui();
  const queryClient = useQueryClient();
  const { request } = useRequestContext();
  const { article } = useArticleContext();

  return (
    <FileUpload
      type="photo"
      variant="grid"
      size={size}
      uploadData={{
        type:
          article.taskType === 'analyze_article' ? 'requalification-defect-photo' : 'defect-photo',
        articleDefectId: defect?.id,
        articleActionId: action?.id,
      }}
      ariaLabel={t({
        id: 'article.forms.actions.defect-photo.prompt',
        message: 'Add defect photos',
      })}
      deleteWithApi
      disabled={isDisabled}
      showDisabledInput={
        defect?.id.startsWith(TEMPORARY_ID_PREFIX) || action?.id.startsWith(TEMPORARY_ID_PREFIX)
      }
      media={action?.media ?? defect?.media ?? []}
      onChange={() => {
        queryClient.invalidateQueries({ queryKey: ['requests', request.id] });
      }}
      isInvalid={isInvalid}
      style={{ width: '100%' }}
      label={label}
      labelFontWeight="regular"
      secondaryActionIconOnly={secondaryActionIconOnly}
      withQrCode
    />
  );
};
